var _style, _path, _circle, _path2, _polygon, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _polygon2, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _g, _path32, _g2, _path33, _path34;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTlnLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 324 324",
    style: {
      enableBackground: "new 0 0 324 324"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFC729;}\n\t.st1{fill:none;stroke:#FFC729;stroke-width:2;stroke-miterlimit:10;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:url(#SVGID_00000166657554450472806690000013043431208713309577_);}\n\t.st4{fill:url(#SVGID_00000011721359686611098430000013481083982703384452_);}\n\t.st5{fill:url(#SVGID_00000144302608255569980130000005543937401328252576_);}\n\t.st6{fill:url(#SVGID_00000062883726416895648760000006154744540430152867_);}\n\t.st7{fill:url(#SVGID_00000084500138636676289140000004971095582511860916_);}\n\t.st8{fill:url(#SVGID_00000141429573779396368300000017292973327933363851_);}\n\t.st9{fill:url(#SVGID_00000095334334457862749270000007477785317823093131_);}\n\t.st10{fill:url(#SVGID_00000093156478201578097540000014164470342259692453_);}\n\t.st11{fill:url(#SVGID_00000178202852159046117700000018291475100025198742_);}\n\t.st12{fill:#FFFFFF;}\n\t.st13{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M252.8,82.3c0-3,2.6-5.4,5.8-5.4c3.2,0,5.8,2.4,5.8,5.4c0,3-2.6,5.4-5.8,5.4C255.4,87.7,252.8,85.3,252.8,82.3z  M261.8,82.3c0-1.6-1.4-3-3.2-3s-3.2,1.3-3.2,3c0,1.6,1.4,3,3.2,3S261.8,83.9,261.8,82.3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 258.8,
    cy: 82.3,
    r: 3.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M290.3,139.3"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "30.3,139.3 32.4,139.2 32.9,139.2 31.6,139.3 "
  })), /*#__PURE__*/React.createElement("g", null, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 162,
    r: 162
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 68.7,
    cy: 240,
    r: 3.6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 99.4,
    cy: 251.6,
    r: 3.6
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 127.4,
    cy: 234.1,
    r: 3.6
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 174.4,
    cy: 256.3,
    r: 3.6
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 169.4,
    cy: 271.6,
    r: 3.6
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 197.2,
    cy: 249.1,
    r: 3.6
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 254.1,
    cy: 240.2,
    r: 3.6
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 95.1,
    cy: 225.2,
    r: 3.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M253,243.5c-19.1,23.6-48.1,39-79.4,42.3c-40.4,4.3-80.2-12-103.9-42.5l1.9-1.3 c23.2,29.9,62.2,45.8,101.9,41.6c30.7-3.2,59.1-18.4,77.8-41.5L253,243.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -3326.9363,
    y1: 304.25,
    x2: -3230.6448,
    y2: 304.25,
    gradientTransform: "matrix(-0.9945 0.1051 -0.1051 -0.9945 -3012.1848 880.1848)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008160893,
    style: {
      stopColor: "#030200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    style: {
      stopColor: "#6D5512"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    style: {
      stopColor: "#BC921E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7571,
    style: {
      stopColor: "#ECB826"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8455,
    style: {
      stopColor: "#FFC729"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M260.7,193.9c-7.3,41.5-43.7,73.7-88.5,78.5l-0.2-2.1c43.8-4.6,79.4-36.2,86.5-76.7L260.7,193.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097492254995311823040000011598271165196929186_",
    gradientUnits: "userSpaceOnUse",
    x1: -3158.8381,
    y1: 331.064,
    x2: -3130.9856,
    y2: 331.064,
    gradientTransform: "matrix(-0.9945 0.1051 -0.1051 -0.9945 -3012.1848 880.1848)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC729"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#403D3A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097492254995311823040000011598271165196929186_)"
    },
    d: "M97.5,248.6l-1.5,1.6 c-18.6-15.3-30.2-36.4-32.6-59.5l2.3-0.3l0,0.1C68,213,79.3,233.6,97.5,248.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035515243978825062790000002736988966482197678_",
    gradientUnits: "userSpaceOnUse",
    x1: -3252.3528,
    y1: 507.1622,
    x2: -3233.2261,
    y2: 507.1622,
    gradientTransform: "matrix(-0.909 -0.4169 0.4169 -0.909 -2941.209 -660.2375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008160893,
    style: {
      stopColor: "#030200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    style: {
      stopColor: "#6D5512"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    style: {
      stopColor: "#BC921E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7571,
    style: {
      stopColor: "#ECB826"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8455,
    style: {
      stopColor: "#FFC729"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000035515243978825062790000002736988966482197678_)"
    },
    d: "M236.4,213.1c-7.3,15.8-19.5,28.2-35.5,36 l-1.1-1.9c15.6-7.5,27.5-19.6,34.5-34.9L236.4,213.1C236.4,213.1,236.4,213.1,236.4,213.1z"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.4,255.5l0.2,2.1c-29,3.1-56.9-7.9-74.7-29.2l1.8-1.3C115,247.9,142.2,258.5,170.4,255.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M221.5,212.5c-11.4,17.7-30.4,29.2-52.3,31.5c-13.9,1.5-27.7-1-39.9-7l1.1-1.9c11.8,5.9,25.1,8.2,38.6,6.8 c21.1-2.2,39.6-13.3,50.5-30.4L221.5,212.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.7,239.5c0.3,2.6-1.8,4.9-4.5,5.2c-2.8,0.3-5.3-1.6-5.5-4.2c-0.3-2.6,1.8-4.9,4.5-5.2 C71,235,73.4,236.9,73.7,239.5z M65.9,240.3c0.1,1.4,1.5,2.4,3,2.3c1.5-0.2,2.6-1.4,2.5-2.9c-0.1-1.4-1.5-2.4-3-2.3 C66.9,237.6,65.8,238.9,65.9,240.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.2,239.7c0.3,2.6-1.8,4.9-4.5,5.2c-2.8,0.3-5.3-1.6-5.5-4.2c-0.3-2.6,1.8-4.9,4.5-5.2 C256.4,235.2,258.9,237.1,259.2,239.7z M251.4,240.5c0.1,1.4,1.5,2.4,3,2.3c1.5-0.2,2.6-1.4,2.5-2.9c-0.1-1.4-1.5-2.4-3-2.3 C252.3,237.8,251.2,239.1,251.4,240.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M174.7,271c0.3,2.6-1.8,4.9-4.5,5.2c-2.8,0.3-5.3-1.6-5.5-4.2c-0.3-2.6,1.8-4.9,4.5-5.2 C171.9,266.6,174.4,268.5,174.7,271z M166.9,271.9c0.1,1.4,1.5,2.4,3,2.3c1.5-0.2,2.6-1.4,2.5-2.9c-0.1-1.4-1.5-2.4-3-2.3 S166.8,270.5,166.9,271.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.4,251.1c0.3,2.6-1.8,4.9-4.5,5.2c-2.8,0.3-5.3-1.6-5.5-4.2c-0.3-2.6,1.8-4.9,4.5-5.2 C101.7,246.6,104.2,248.5,104.4,251.1z M96.6,251.9c0.1,1.4,1.5,2.4,3,2.3c1.5-0.2,2.6-1.4,2.5-2.9c-0.1-1.4-1.5-2.4-3-2.3 C97.6,249.2,96.5,250.5,96.6,251.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.1,224.6c0.3,2.6-1.8,4.9-4.5,5.2c-2.8,0.3-5.3-1.6-5.5-4.2c-0.3-2.6,1.8-4.9,4.5-5.2 C97.4,220.2,99.8,222.1,100.1,224.6z M92.3,225.5c0.1,1.4,1.5,2.4,3,2.3c1.5-0.2,2.6-1.4,2.5-2.9c-0.1-1.4-1.5-2.4-3-2.3 C93.3,222.8,92.2,224.1,92.3,225.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M201.8,251.1c-1.1,2.4-4,3.3-6.6,2.2s-3.7-4-2.6-6.4c1.1-2.4,4-3.3,6.6-2.2S202.9,248.7,201.8,251.1z  M194.7,247.8c-0.6,1.3,0.1,2.9,1.4,3.5c1.4,0.6,3,0.1,3.6-1.2c0.6-1.3-0.1-2.9-1.4-3.5C196.9,246,195.3,246.5,194.7,247.8z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.4,255.5c0.3,2.6-1.8,4.9-4.5,5.2c-2.8,0.3-5.3-1.6-5.5-4.2c-0.3-2.6,1.8-4.9,4.5-5.2 C176.7,251,179.2,252.9,179.4,255.5z M171.7,256.3c0.1,1.4,1.5,2.4,3,2.3c1.5-0.2,2.6-1.4,2.5-2.9c-0.1-1.4-1.5-2.4-3-2.3 C172.6,253.6,171.5,254.9,171.7,256.3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M131.9,233.3c0.3,2.6-1.8,4.9-4.5,5.2c-2.8,0.3-5.3-1.6-5.5-4.2c-0.3-2.6,1.8-4.9,4.5-5.2 C129.2,228.9,131.6,230.7,131.9,233.3z M124.1,234.2c0.1,1.4,1.5,2.4,3,2.3c1.5-0.2,2.6-1.4,2.5-2.9c-0.1-1.4-1.5-2.4-3-2.3 C125.1,231.5,124,232.7,124.1,234.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094594961143762180370000018192460535658974648_",
    gradientUnits: "userSpaceOnUse",
    x1: -529.1838,
    y1: 221.3385,
    x2: -529.1838,
    y2: 303.9991,
    gradientTransform: "matrix(-1 0 0 -1 -362.2956 491.9442)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.411,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9281,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000094594961143762180370000018192460535658974648_)"
    },
    points: "30.8,187.9 303,187.9 303,270.6 30.8,270.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032607406494985227060000018015770124869976725_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.5987,
    y1: 77.8312,
    x2: 165.8995,
    y2: 77.8312
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008160893,
    style: {
      stopColor: "#030200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    style: {
      stopColor: "#6D5512"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    style: {
      stopColor: "#BC921E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7571,
    style: {
      stopColor: "#ECB826"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8455,
    style: {
      stopColor: "#FFC729"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000032607406494985227060000018015770124869976725_)"
    },
    d: "M28.6,141c0.4-33.8,14.9-65.6,40.7-89.4 c25.9-23.8,60.2-37,96.6-37v2.3c-35.8,0-69.4,12.9-94.9,36.3c-25.4,23.4-39.6,54.6-40,87.8L28.6,141z"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.4,63.1c23.1-23,55.7-36.2,89.5-36.2c43.6,0,84.3,21.9,106.1,57l-2.1,1.1c-21.4-34.5-61.2-55.9-104-55.9 c-33.1,0-65.1,12.9-87.7,35.4L76.4,63.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020371549416321634880000012325515061285063040_",
    gradientUnits: "userSpaceOnUse",
    x1: 62.591,
    y1: 78.5881,
    x2: 165.8995,
    y2: 78.5881
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008160893,
    style: {
      stopColor: "#030200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    style: {
      stopColor: "#6D5512"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    style: {
      stopColor: "#BC921E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7571,
    style: {
      stopColor: "#ECB826"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8455,
    style: {
      stopColor: "#FFC729"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000020371549416321634880000012325515061285063040_)"
    },
    d: "M62.6,115.2 c12.5-43.4,54.9-73.8,103.3-73.8v2.3c-47.3,0-88.8,29.6-100.9,72.1L62.6,115.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096040841288807888330000006499664651806746296_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.9391,
    y1: 107.3561,
    x2: 272.8212,
    y2: 107.3561
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC729"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#403D3A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096040841288807888330000006499664651806746296_)"
    },
    d: "M242.9,75.3l1.8-1.5 c18.1,18.4,28.1,42.3,28.1,67.2l-2.5,0.1l0-0.1C270.4,116.5,260.6,93.2,242.9,75.3z"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M241.2,97.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119817716716714233030000008652497471597847984_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.554,
    y1: -62.6937,
    x2: 23.0746,
    y2: -62.6937,
    gradientTransform: "matrix(0.8681 0.4965 -0.4965 0.8681 64.636 132.214)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.008160893,
    style: {
      stopColor: "#030200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3243,
    style: {
      stopColor: "#6D5512"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    style: {
      stopColor: "#BC921E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7571,
    style: {
      stopColor: "#ECB826"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8455,
    style: {
      stopColor: "#FFC729"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119817716716714233030000008652497471597847984_)"
    },
    d: "M85.3,101.2c9.3-16.2,23.6-28.3,41.4-35 l1,2.2c-17.4,6.5-31.3,18.3-40.3,34L85.3,101.2C85.3,101.2,85.3,101.2,85.3,101.2z"
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M165.9,59.6v-2.3c31.3,0,59.9,14.8,76.4,39.6l-2.1,1.2C224.1,74,196.4,59.6,165.9,59.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M207,85.1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M93.1,140.9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.6,100.5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.6,99.8c14.1-17.6,35.7-27.7,59.3-27.7c15,0,29.5,4.2,41.8,12l-1.4,1.9c-11.9-7.6-25.9-11.6-40.4-11.6 c-22.8,0-43.7,9.8-57.4,26.8L106.6,99.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172409084127081100360000002121937925959124638_",
    gradientUnits: "userSpaceOnUse",
    x1: 165.8995,
    y1: 110.1261,
    x2: 223.8858,
    y2: 110.1261
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC729"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#403D3A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000172409084127081100360000002121937925959124638_)"
    },
    d: "M165.9,88.8v-2.3c29.1,0,54,20.2,58,47 l-2.4,0.3C217.7,108.1,193.8,88.8,165.9,88.8z"
  }), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "222,141 222,141 224.4,141  "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.4,66.5c0-2.8,2.4-5.1,5.4-5.1c3,0,5.4,2.3,5.4,5.1c0,2.8-2.4,5.1-5.4,5.1C71.9,71.5,69.4,69.3,69.4,66.5z  M77.8,66.5c0-1.5-1.3-2.8-3-2.8c-1.6,0-3,1.2-3,2.8c0,1.5,1.3,2.8,3,2.8C76.5,69.2,77.8,68,77.8,66.5z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235.8,71.8c0-2.8,2.4-5.1,5.4-5.1c3,0,5.4,2.3,5.4,5.1c0,2.8-2.4,5.1-5.4,5.1 C238.2,76.8,235.8,74.6,235.8,71.8z M244.2,71.8c0-1.5-1.3-2.8-3-2.8c-1.6,0-3,1.2-3,2.8c0,1.5,1.3,2.8,3,2.8 C242.9,74.6,244.2,73.3,244.2,71.8z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271.2,81.1c-3,0-5.4,2.3-5.4,5.1c0,2.8,2.4,5.1,5.4,5.1c3,0,5.4-2.3,5.4-5.1 C276.7,83.4,274.2,81.1,271.2,81.1z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M237.4,100.5c0-2.8,2.4-5.1,5.4-5.1c3,0,5.4,2.3,5.4,5.1c0,2.8-2.4,5.1-5.4,5.1 C239.9,105.5,237.4,103.3,237.4,100.5z M245.8,100.5c0-1.5-1.3-2.8-3-2.8c-1.6,0-3,1.2-3,2.8c0,1.5,1.3,2.8,3,2.8 C244.5,103.2,245.8,102,245.8,100.5z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.9,63.9c1.4-2.4,4.6-3.2,7.2-1.7c2.6,1.5,3.6,4.7,2.2,7.1c-1.4,2.4-4.6,3.2-7.2,1.7 C125.5,69.5,124.5,66.3,125.9,63.9z M133.2,68c0.8-1.3,0.2-3.1-1.2-3.9s-3.2-0.4-4,0.9c-0.8,1.3-0.2,3.1,1.2,3.9 C130.7,69.8,132.5,69.4,133.2,68z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M156.3,58.7c0-2.8,2.4-5.1,5.4-5.1s5.4,2.3,5.4,5.1c0,2.8-2.4,5.1-5.4,5.1S156.3,61.4,156.3,58.7z M164.7,58.7 c0-1.5-1.3-2.8-3-2.8s-3,1.2-3,2.8c0,1.5,1.3,2.8,3,2.8S164.7,60.2,164.7,58.7z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.8,103.8c0-2.8,2.4-5.1,5.4-5.1s5.4,2.3,5.4,5.1c0,2.8-2.4,5.1-5.4,5.1S99.8,106.6,99.8,103.8z  M108.2,103.8c0-1.5-1.3-2.8-3-2.8s-3,1.2-3,2.8c0,1.5,1.3,2.8,3,2.8S108.2,105.4,108.2,103.8z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M204.5,87.6c0-2.8,2.4-5.1,5.4-5.1c3,0,5.4,2.3,5.4,5.1c0,2.8-2.4,5.1-5.4,5.1 C206.9,92.7,204.5,90.4,204.5,87.6z M212.9,87.6c0-1.5-1.3-2.8-3-2.8c-1.6,0-3,1.2-3,2.8c0,1.5,1.3,2.8,3,2.8 C211.5,90.4,212.9,89.2,212.9,87.6z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.8,87.6c0-2.8,2.4-5.1,5.4-5.1c3,0,5.4,2.3,5.4,5.1c0,2.8-2.4,5.1-5.4,5.1 C160.3,92.7,157.8,90.4,157.8,87.6z M166.2,87.6c0-1.5-1.3-2.8-3-2.8c-1.6,0-3,1.2-3,2.8c0,1.5,1.3,2.8,3,2.8 C164.9,90.4,166.2,89.2,166.2,87.6z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M217.8,137c0-2.8,2.4-5.1,5.4-5.1c3,0,5.4,2.3,5.4,5.1c0,2.8-2.4,5.1-5.4,5.1 C220.2,142.1,217.8,139.8,217.8,137z M226.2,137c0-1.5-1.3-2.8-3-2.8c-1.6,0-3,1.2-3,2.8c0,1.5,1.3,2.8,3,2.8 C224.8,139.8,226.2,138.6,226.2,137z"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 105.7,
    cy: 103.8,
    r: 3.6
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 130.6,
    cy: 66.6,
    r: 3.6
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 161.7,
    cy: 58.7,
    r: 3.6
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 74.9,
    cy: 67.3,
    r: 3.6
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 163.2,
    cy: 87.6,
    r: 3.6
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 209.9,
    cy: 87.6,
    r: 3.6
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 241.2,
    cy: 71.8,
    r: 3.6
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 242.9,
    cy: 101.2,
    r: 3.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125600166239238800090000009632012554881063586_",
    gradientUnits: "userSpaceOnUse",
    x1: 153.7177,
    y1: 115.9147,
    x2: 153.7177,
    y2: 217.4483,
    gradientTransform: "matrix(1 0 0 1 8.2823 -70.5881)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2515,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1353
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9281,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 25.9,
    y: 45.3,
    style: {
      fill: "url(#SVGID_00000125600166239238800090000009632012554881063586_)"
    },
    width: 272.2,
    height: 101.5
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M25.3,101.4h94.4v22.3H85.5v92.1H59.3v-92.1h-34V101.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119.5,101.4h26.1v91.9h52.7v22.4h-78.9V101.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M198.4,101.4h26.7l30.1,49.7c6.8,11.5,15.7,30.1,15.7,30.1h0.3c0,0-1.4-20.4-1.4-33.5v-46.3h25.1v114.4H268 l-29.8-49c-6.9-11.5-15.8-30.6-15.8-30.6H222c0,0,1.4,20.6,1.4,33.7v46h-25.1V101.4z"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M223.8,227.5h-12.1c-2.5-2.8-5-5.5-7.5-8.3c1.6-1.1,3.1-2.2,4.7-3.3c5,0,10,0,14.9,0C223.8,219.7,223.8,223.6,223.8,227.5z "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M43.1,224.1l7.6,12.9l-3,1.8l-2.8-4.7l-12.6,7.4l-2.1-3.6l12.6-7.4l-2.7-4.6L43.1,224.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M46.7,244L46.7,244c2-0.3,3.3,0.2,4.2,1.6c0.2,0.3,0.3,0.5,0.4,0.7l-2.7,1.9l-0.1-0.1 c-0.1-0.2-0.2-0.5-0.4-0.7c-1.2-1.7-3-2.1-5.1-0.6l-4.9,3.5l-2.2-3.1l10.6-7.5l2.1,3L46.7,244z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M47.6,262.5l1.4-1.2l0-0.1c-1.8,0.2-3.1-0.2-4.2-1.6c-1.9-2.3-1.5-4.7,0.7-6.6l6.6-5.5l2.5,2.9l-6,5.1 c-1.1,0.9-1.3,2-0.4,3c1,1.2,2.5,1.2,3.7,0.1l5.6-4.7l2.4,2.9l-9.9,8.3L47.6,262.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M54.6,264.4l2.6,2.5c-0.7,1-0.5,2.2,0.5,3.2c1,1,1.9,1.1,2.6,0.4c0.8-0.8-0.2-2-1.2-3.5 c-1.3-1.9-2.6-4-0.5-6.2c1.9-1.9,4.6-1.2,6.7,0.9c2.6,2.5,2.8,4.9,1.4,6.8l-2.5-2.5c0.5-0.8,0.3-1.7-0.6-2.5 c-0.8-0.8-1.7-1-2.3-0.4c-0.7,0.7,0.2,1.8,1.3,3.3c1.4,1.9,2.8,4.2,0.5,6.5c-2,2-4.8,1.3-7.2-1.1 C53.2,269.3,52.9,266.4,54.6,264.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M70,266.9l1.5,1.3l2.7-3.2l2.9,2.4l-2.7,3.2l1.9,1.6l-1.6,1.9l-1.9-1.6l-4.2,4.9c-0.6,0.7-0.4,1.3,0.3,1.9 c0.2,0.2,0.5,0.4,0.7,0.5l0.1,0.1l-1.8,2.2c-0.4-0.2-1-0.6-1.8-1.3c-1.8-1.6-2.6-3.2-0.9-5.2l4.7-5.6l-1.5-1.3L70,266.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M73.4,278.3c2.3-3.2,6.2-4,9.4-1.7c1.5,1.1,2.3,2.4,2.7,3.9c0.4,2-0.4,4.2-1.9,6.2l-7.7-5.5 c-0.9,1.7-0.8,3.3,0.8,4.4c1,0.7,1.9,0.8,2.7,0.3l3,2.2c-1.9,1.5-4.6,1.7-7.3-0.3C71.5,285.4,71.1,281.5,73.4,278.3z M77.2,279.5 l4.5,3.2c0.9-1.5,0.8-3-0.5-3.9C79.8,277.8,78.4,278.2,77.2,279.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M85.6,286.9c2-3.5,5.3-4.9,8.3-3.2c1.5,0.9,2.2,2.2,2.3,3.8l0,0c0.4-0.7,0.9-1.7,1.4-2.7l2-3.5l3.3,1.9 l-9,15.8l-3.2-1.8l0.9-1.7l0,0c-1.4,1-3.1,0.9-4.6,0.1C84.1,294,83.5,290.7,85.6,286.9z M93.9,291.6c1.1-2,1.1-3.9-0.6-4.9 c-1.6-0.9-3.1,0.1-4.3,2.1c-1.2,2-1.1,3.8,0.4,4.7C91.1,294.4,92.8,293.6,93.9,291.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M109.8,286.6l3.9,1.5l-5.3,13.6l7.8,3l-1.3,3.3l-11.7-4.5L109.8,286.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M118.8,302.5c1-3.8,4.4-5.9,8.2-4.9c1.8,0.5,3,1.5,3.9,2.8c1,1.8,1.1,4,0.4,6.5l-9.1-2.5 c-0.3,1.9,0.4,3.4,2.2,3.8c1.2,0.3,2,0.1,2.6-0.6l3.6,1c-1.2,2-3.8,3.2-7,2.3C119.5,309.8,117.7,306.3,118.8,302.5z M122.8,302.3 l5.3,1.5c0.4-1.8-0.3-3.1-1.8-3.5C124.6,299.8,123.5,300.6,122.8,302.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M140.8,312.6L140.8,312.6c-1.1,1-2.3,1.6-4.2,1.2c-2.5-0.4-4.2-2.1-3.7-4.6c0.5-2.8,2.8-3.2,5.7-3.1 c2.3,0.1,3.3-0.1,3.5-1.1c0.2-0.9-0.3-1.6-1.6-1.9c-1.4-0.2-2.3,0.3-2.5,1.3l-3.5-0.6c0.5-2.2,2.6-3.9,6.4-3.3 c1.6,0.3,2.8,0.7,3.6,1.4c1.2,1,1.6,2.4,1.3,4.2l-1.1,6.6c-0.2,1-0.1,1.6,0.2,1.9l0,0.2l-3.7-0.6 C140.8,313.9,140.8,313.3,140.8,312.6z M141.4,309.6l0.3-1.7c-0.6,0.2-1.5,0.3-2.3,0.4c-1.7,0.1-2.6,0.4-2.8,1.5 c-0.2,1.1,0.6,1.7,1.6,1.8C139.8,311.9,141.1,311,141.4,309.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M152.2,304.8L152.2,304.8c1-1.7,2.3-2.4,3.9-2.2c0.4,0,0.6,0.1,0.8,0.2l-0.3,3.3l-0.1,0 c-0.3-0.1-0.5-0.1-0.8-0.1c-2.1-0.2-3.5,1-3.7,3.5l-0.5,6l-3.8-0.3l1-12.9l3.7,0.3L152.2,304.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M162.2,304.9L162.2,304.9c0.9-1.6,2.2-2.4,4.1-2.4c2.9,0,4.5,1.9,4.6,4.8l0.1,8.5l-3.8,0l-0.1-7.8 c0-1.4-0.8-2.4-2.2-2.3c-1.5,0-2.5,1.2-2.5,2.9l0.1,7.3l-3.8,0l-0.1-13l3.7,0L162.2,304.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M173.1,309.3c-0.4-3.9,1.9-7.1,5.8-7.6c1.8-0.2,3.4,0.2,4.6,1.1c1.6,1.2,2.5,3.4,2.8,5.9l-9.4,1.1 c0.5,1.9,1.6,3,3.5,2.8c1.2-0.1,1.9-0.7,2.2-1.5l3.7-0.4c-0.4,2.4-2.3,4.3-5.6,4.7C176.5,315.8,173.5,313.1,173.1,309.3z  M176.7,307.6l5.5-0.6c-0.3-1.8-1.5-2.8-3-2.6C177.5,304.6,176.7,305.8,176.7,307.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M191.3,302.5L191.3,302.5c0.5-1.9,1.5-2.9,3.1-3.2c0.4-0.1,0.6-0.1,0.8-0.1l0.7,3.3l-0.1,0 c-0.3,0-0.5,0-0.8,0.1c-2,0.4-3.1,1.9-2.6,4.4l1.2,5.9l-3.8,0.8l-2.6-12.7l3.6-0.7L191.3,302.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M200.9,292.6l4-1.4l7.1,5.8c1.6,1.4,3.9,3.7,3.9,3.7l0,0c0,0-1.3-3-2-4.9l-2.5-6.9l3.7-1.3l6.1,17.1l-4,1.4 l-7.1-5.7c-1.6-1.4-4-3.7-4-3.7l0,0c0,0,1.3,3,2,5l2.4,6.9l-3.7,1.3L200.9,292.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M221.7,297.4c-1.7-3.5-0.6-7.4,2.9-9.1c1.7-0.8,3.2-0.9,4.7-0.5c1.9,0.6,3.5,2.3,4.6,4.6l-8.5,4.2 c1.1,1.6,2.5,2.2,4.2,1.4c1.1-0.5,1.5-1.3,1.6-2.2l3.3-1.6c0.4,2.3-0.7,4.9-3.7,6.3C227.1,302.4,223.4,300.9,221.7,297.4z  M224.5,294.6l5-2.4c-0.9-1.6-2.3-2.1-3.7-1.4C224.3,291.5,224,292.9,224.5,294.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M231.3,285.3l1.7-1l-2.1-3.6l3.2-1.9l2.1,3.6l2.2-1.3l1.3,2.1l-2.2,1.3l3.3,5.5c0.5,0.8,1.1,0.8,1.9,0.3 c0.2-0.1,0.5-0.3,0.7-0.5l0.2-0.1l1.5,2.5c-0.3,0.3-0.9,0.8-1.8,1.3c-2.1,1.2-3.9,1.4-5.2-0.9l-3.7-6.2l-1.7,1L231.3,285.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M239.5,280.6l3.1-2.3l4.1,3.2c1.3,1,3,2.8,3,2.8l0,0c0,0-1.2-2.3-1.8-3.8l-1.9-4.8l2.6-1.9l4.1,3.2 c1.3,1,3.1,2.8,3.1,2.8l0,0c0,0-1.2-2.2-1.8-3.7l-1.9-4.9l3-2.3l4.6,12.8l-2.9,2.2l-4.3-3.4c-1.2-0.9-3-2.7-3-2.7l0,0 c0,0,1.1,2.3,1.7,3.7l2,5.1l-2.8,2.1L239.5,280.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M259.7,273.3c-2.7-2.8-2.8-6.9,0.2-9.7c3-2.8,7-2.6,9.7,0.3c2.7,2.8,2.8,6.9-0.2,9.7 C266.4,276.4,262.4,276.1,259.7,273.3z M266.8,266.5c-1.7-1.8-3.6-2.3-5-1c-1.4,1.3-1,3.3,0.7,5.1c1.7,1.8,3.6,2.3,5,0.9 C268.9,270.2,268.5,268.3,266.8,266.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M270.4,256.6L270.4,256.6c-0.8-1.9-0.5-3.2,0.5-4.4c0.2-0.3,0.4-0.5,0.6-0.5l2.5,2.2l-0.1,0.1 c-0.2,0.2-0.4,0.4-0.6,0.6c-1.4,1.5-1.3,3.4,0.6,5.1l4.5,4l-2.5,2.9l-9.7-8.6l2.4-2.8L270.4,256.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M281.6,250.7l0.3,1.8l3.5,2.6l-2.3,3l-14.6-10.8l2.3-3l4.5,3.4c1.5,1.1,2.6,2.1,3.3,2.6l-1.2-6.2l2.7-3.6 l1.1,6.6l9.6,0.7l-2.7,3.6L281.6,250.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M279.7,238.6l3.3-5.6l1.6,0.9l-1.1,1.9l4.9,2.8l-1.1,1.9l-4.9-2.8l-1.1,1.9L279.7,238.6z M283.6,231.8 l1.5-2.6l2.3,0.6c1.1,0.3,2.7,0.8,2.7,0.8l0,0c0,0-1.3-1.1-2.1-1.9l-1.6-1.7l1.5-2.6l6.5,3.7l-1,1.7l-1.9-1.1 c-1.1-0.6-2.7-1.6-2.7-1.6l0,0.1c0,0,1.3,1.3,2.2,2.2l1.7,1.8l-0.9,1.5l-2.4-0.6c-1.2-0.3-3-0.8-3-0.8l0,0c0,0,1.7,0.9,2.8,1.5 l1.9,1.1l-1,1.7L283.6,231.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M302.6,230l3.2-7l1.5,0.7l-3.2,7L302.6,230z"
  })))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M166.2,10.2c-3.2,0-5.8,2.4-5.8,5.4c0,3,2.6,5.4,5.8,5.4c3.2,0,5.8-2.4,5.8-5.4C172,12.7,169.4,10.2,166.2,10.2 z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M166.2,36.9c-3.2,0-5.8,2.4-5.8,5.4c0,3,2.6,5.4,5.8,5.4c3.2,0,5.8-2.4,5.8-5.4C172,39.3,169.4,36.9,166.2,36.9 z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTlnLogo);
export default __webpack_public_path__ + "static/media/tln-logo.f20b0e9a7db60ea8f6e74f1f55b35ce5.svg";
export { ForwardRef as ReactComponent };